<template>
  <div :style="{ background: '#FFFFFF', height: '100vh' }">
    <OnboardingLayout
      title="Start your Arnergy Journey!"
      description="Join the thousands of Arnergy users all over Africa who are enjoying uninterrupted power supply with our solar solution."
      @onButtonClick="handleContinue"
      :canContinue="canContinue"
      :imageDescription="welcomeText"
    >
      <div class="choose-package">
        <div class="boxes">
          <div v-for="item in paymentTypes" :key="item.id">
            <onboarding-select-button
              :title="item.title"
              :description="item.description"
              :isActive="activePaymentType && activePaymentType.id == item.id"
              :image="null"
              @setActive="updateCustomerType(item)"
            />
          </div>
        </div>
      </div>
    </OnboardingLayout>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters, mapActions } from "vuex";
import ButtonOnboardingPackage from "@/components/pages/kitchen/ButtonOnboardingPackage";
import OnboardingSelectButton from "@/components/pages/kitchen/OnboardingSelectButton";
// import SideIndicator from "../kitchen/Onboarding/SideIndicator.vue";
// import ModalCalculate from "../kitchen/Onboarding/ModalCalculate";
// import ModalMain from "../kitchen/Onboarding/ModalMain.vue";
import MoneyFormat from "vue-money-format";
import OnboardingService from "@/services/onboarding.js";

import OnboardingTopBar from "@/components/OnboardingTopBar.vue";
import OnboardingButton from "@/components/OnboardingButton.vue";
import OnboardingLayout from "@/components/layouts/onboarding-layout.vue";

export default {
  name: "Onboarding",
  computed: {
    ...mapGetters(["getUserSession"]),
    filteredPaymentTypes() {
      return this.paymentTypes.filter(item => item.key !== "OS");
    }
  },
  components: {
    OnboardingLayout,
    ButtonOnboardingPackage,
    OnboardingSelectButton,
    // SideIndicator,
    // ModalCalculate,
    // ModalMain,
    MoneyFormat,
    OnboardingTopBar,
    OnboardingButton
  },
  data() {
    return {
      welcomeText: "Choose a Payment Type",
      showLoading: false,
      canContinue: false,
      activePackageType: {},
      activePaymentType: {},
      paymentTypes: [
        {
          id: 0,
          key: "LO",
          title: "Lease to Own (LO)",
          description:
            "This allows you to pay monthly over a specified lease tenor and own the system afterward"
        },
        {
          id: 1,
          key: "OS",
          title: "Outright Sale (OS)",
          description:
            "This allows you to pay once and the package becomes yours forever"
        }
      ]
    };
  },
  methods: {
    updateActivePaymentType(item) {
      this.activePaymentType = item;
      this.canContinue = true;
    },
    updateCustomerType(item) {
      this.activePaymentType = item;
      this.welcomeText = item.description;
      this.canContinue = true;
    },
    updateGlobalState(value) {
      const onboardingCustomerState = this.$store.state.onboardingCustomerState;
      this.$store.commit("saveOnboardingCustomerState", {
        ...onboardingCustomerState,
        paymentType: value
      });
    },
    handleContinue() {
      OnboardingService.updateDbData({
        // currentPageName: this.nextPageName,
        packagetype: this.activePaymentType.key
      });
      if (this.activePaymentType.key == "LO") {
        this.navTo("OnboardStandardLO");
      } else if (this.activePaymentType.key == "OS") {
        this.navTo("OnboardStandardOS");
      }
      this.updateGlobalState(this.activePaymentType.key);
    }
  },
  async mounted() {}
};
</script>

<style lang="scss" scoped>
.content {
  display: flex;
  width: 100%;
  padding: 0rem 14rem;
  font-family: "DM Sans";
  background: #ffffff;

@media screen and (max-width: 600px) {
  padding: 0rem 2rem;
  flex-direction: column-reverse;
}
}

.choose-package {
  width: 70%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.button {
  border: 1px solid #0892d0;
  border-radius: 5px;
  padding: 7px 10px;
}

.welcome {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 39px;
  color: #0892d0;
  margin-bottom: 2.1rem;
}

.subtext {
  font-family: "DM Sans";
  max-width: 58.1rem;
  width: 100%;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #727272;
  margin-bottom: 2.7rem;
}

.choice-type {
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 2.7rem;
  color: #fe7a11;
}

.boxes {
  display: flex;
  margin-bottom: 2.7rem;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
}

.package {
  display: flex;
  margin-bottom: 2.7rem;
}

.right-image {
  display: flex;
  flex-direction: column;
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.man-woman {
  margin-bottom: 9rem;
}

.continue {
  display: block;
  margin-left: auto;
  margin-right: 0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}

@media screen and (max-width: 430px) {
  .boxes {
    flex-direction: column;
    gap: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/standard/index.vue